// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__QVzfo","blur":"style_blur__aESc3","no-logo":"style_no-logo__vI7GI","has-logo":"style_has-logo__EMV7Z"};